

















































































































































import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "InvestorTopGuide",
})
export default class InvestorTopGuide extends Vue {}
